/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Divider, Image, Modal, Row, Typography } from "antd";
// import Slider from "react-slick";
import { MetaTags } from "react-meta-tags";
import enquiryImage from "../../assets/images/img_p (1).png";
import Logo1 from "../../assets/images/logo-dark.png";
// import {
//   MailFilled,
// } from "@ant-design/icons";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router";
import "react-range-slider-input/dist/style.css";

// import { SampleNextArrow, SamplePrevArrow } from "../../helpers/utils";

const EnquiryDetails = (props) => {
  const media = useMedia();
  const history = useHistory();
  const enquiryMode =
    props &&
    props.location &&
    props.location.state &&
    props.location.state &&
    props.location.state.mode !== undefined
      ? props.location.state.mode
      : "";
  const enquiryNo =
    props &&
    props.location &&
    props.location.state &&
    props.location.state.mode === "booking"
      ? props.location.state.booking.bookingNo
      : props && props.location && props.location.state
      ? props.location.state.enquiryNo
      : "";
  console.log(props, "props");
  console.log(enquiryMode, "enquiryMode");
  console.log(enquiryNo, "enquiryNo");

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Query | Plan mi trip</title>
        </MetaTags>
      </div>
      <Col
        md={24}
        lg={24}
        xl={24}
        xxl={24}
        sm={24}
        xs={24}
        className="bg-[ghostwhite] min-h-[100vh] pt-8 pb-8"
      >
        <Row
          className={
            media == "sm"
              ? "pr-[6%] pl-[6%] w-[100%]"
              : media == "xs"
              ? "pr-[40px] pl-[40px] w-[100%]"
              : media == "md"
              ? "pr-[7%] pl-[7%] w-[100%]"
              : media == "lg"
              ? "pr-[10%] pl-[10%] w-[100%]"
              : media == "xxl"
              ? "pr-[9%] pl-[11%] w-[100%]"
              : "pr-[8%] pl-[6.5%] w-[100%]"
          }
          style={{
            overflow: "hidden",
          }}
        >
          <Col
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            sm={24}
            xs={24}
            className="flex flex-col "
          >
            <Image src={Logo1} preview={false} height={65} width={150} />
            <div className="mt-[80px]">
              <h1 className="text-[#eb3e43] text-start uppercase font-semibold package-fonts text-[48px] mb-4">
                Thank You !
              </h1>
              <h1 className="mb-4 text-start package-fonts font-medium text-[black] text-[28px]">
                Get the Best Holiday Planned by Experts!
              </h1>
              <p className="mb-5 text-start package-fonts text-[black] text-[14px]">
                Thank you for choosing PlanMiTrip.com for your Holiday
                {enquiryMode === "booking" ? "" : "Requirement"}
                {enquiryMode === "booking"
                  ? "Your Booking Number"
                  : "Your Query Number"}{" "}
                is <strong>{enquiryNo ? enquiryNo : ""}</strong> , One of our
                travel consultant will revert back to you with the best
                available options with cheapest prices.
              </p>
              <div
                className={
                  media === "md" ||
                  media === "lg" ||
                  media === "sm" ||
                  media === "xs"
                    ? "mt-1 w-[60%] bg-[#eb3e43] hover:bg-[red] text-center text-[14px] leading-loose track-wider mt-1"
                    : "mt-1 w-[30%] bg-[#eb3e43] hover:bg-[red] text-center text-[14px] leading-loose track-wider mt-1"
                }
                style={{
                  borderRadius: "25px",
                  border: "1px solid #eb3e43",
                  // padding: "4px 20px",
                  fontFamily: "Poppins",
                  padding: "4px 22px",
                  color: "#ffffff",
                  cursor: "pointer",
                }}
                onClick={() => {
                  history.push({
                    pathname: `/`,
                  });
                }}
              >
                <h1 className="">Go to Home Page</h1>
              </div>
            </div>
          </Col>
          <Col
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            sm={24}
            xs={24}
            className={
              media === "sm" || media === "xs"
                ? "h-[86vh] mt-5"
                : "pl-4 h-[86vh]"
            }
          >
            <Image
              src={enquiryImage}
              preview={false}
              height={"100%"}
              width={"90%"}
              className="z-1000"
            />
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};

EnquiryDetails.propTypes = {
  location: PropTypes.any,
};

export default withRouter(EnquiryDetails);
